import React from 'react';
import PropTypes from 'prop-types';

class Footer extends React.PureComponent {

  static contextTypes = {
    router: PropTypes.object,
  };

  gotoRegistration = () => {
    this.context.router.history.push('/registration');
  };

  gotoSignIn = () => {
    this.context.router.history.push('/signin');
  };

  render() {
    return (
      <ul className={`box-footer-holder ${this.props.reverse ? 'centered' : ''}`}>
        {!this.props.empty && this.props.reverse ? (
          <React.Fragment>
            <li>Already have an account?</li>
            <li>
              <span onClick={this.gotoSignIn}>Sign in</span>
            </li>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <li>Don’t have an account?</li>
            <li>
              <span onClick={this.gotoRegistration}>Create account</span>
            </li>
          </React.Fragment>
        )}
      </ul>
    )
  }
};

export default Footer;
